import React from 'react';
import { Modal, Table, Tag, Icon, Tabs, Button } from 'antd';
import { toBRL } from '~/components/UI/InputCurrency';

var TabPane = Tabs.TabPane;
var Column = Table.Column;

function GenerateSummaryModal(props) {
    var visible = props.visible;
    var onClose = props.onClose;
    var summary = props.summary;

    if (!summary) return null;

    var created = summary.created || [];
    var updated = summary.updated || [];
    var total = summary.total || 0;
    var totalCreated = created.length;
    var totalUpdated = updated.length;
    var totalAffected = totalCreated + totalUpdated;
    var unchanged = total - totalAffected;
    if (unchanged < 0) unchanged = 0;

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onClose}
            width={850}
            bodyStyle={{ padding: 0 }}
            footer={null}
        >
            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                padding: '28px 32px',
                borderRadius: '4px 4px 0 0',
                color: '#fff',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                    <Icon type="check-circle" theme="filled" style={{ fontSize: 28, marginRight: 12 }} />
                    <span style={{ fontSize: 20, fontWeight: 600 }}>Mensalidades processadas</span>
                </div>
                <span style={{ fontSize: 14, opacity: 0.9 }}>
                    {total} mensalidade{total !== 1 ? 's' : ''} verificada{total !== 1 ? 's' : ''} no período
                </span>
            </div>

            {/* Stats cards */}
            <div style={{
                display: 'flex',
                padding: '20px 32px',
                gap: 16,
                borderBottom: '1px solid #f0f0f0',
            }}>
                <div style={{
                    flex: 1,
                    background: '#f6ffed',
                    border: '1px solid #b7eb8f',
                    borderRadius: 8,
                    padding: '16px 20px',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: 28, fontWeight: 700, color: '#52c41a' }}>{totalCreated}</div>
                    <div style={{ fontSize: 13, color: '#389e0d', marginTop: 2 }}>
                        <Icon type="plus-circle" style={{ marginRight: 4 }} />
                        Nova{totalCreated !== 1 ? 's' : ''}
                    </div>
                </div>
                <div style={{
                    flex: 1,
                    background: '#e6f7ff',
                    border: '1px solid #91d5ff',
                    borderRadius: 8,
                    padding: '16px 20px',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: 28, fontWeight: 700, color: '#1890ff' }}>{totalUpdated}</div>
                    <div style={{ fontSize: 13, color: '#096dd9', marginTop: 2 }}>
                        <Icon type="edit" style={{ marginRight: 4 }} />
                        Atualizada{totalUpdated !== 1 ? 's' : ''}
                    </div>
                </div>
                <div style={{
                    flex: 1,
                    background: '#fafafa',
                    border: '1px solid #d9d9d9',
                    borderRadius: 8,
                    padding: '16px 20px',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: 28, fontWeight: 700, color: '#8c8c8c' }}>{unchanged}</div>
                    <div style={{ fontSize: 13, color: '#8c8c8c', marginTop: 2 }}>
                        <Icon type="check" style={{ marginRight: 4 }} />
                        Sem alteração
                    </div>
                </div>
            </div>

            {/* Content */}
            <div style={{ padding: '16px 32px 24px' }}>
                {totalAffected === 0 ? (
                    <div style={{ textAlign: 'center', padding: '32px 0' }}>
                        <Icon type="smile" style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
                        <div style={{ fontSize: 16, fontWeight: 500, color: '#262626', marginBottom: 6 }}>
                            Tudo em dia!
                        </div>
                        <div style={{ fontSize: 14, color: '#8c8c8c' }}>
                            Todas as {total} mensalidades já estavam atualizadas. Nenhuma alteração foi necessária.
                        </div>
                    </div>
                ) : (
                    <Tabs
                        defaultActiveKey={totalCreated > 0 ? 'created' : 'updated'}
                        type="card"
                    >
                        {totalCreated > 0 && (
                            <TabPane
                                tab={
                                    <span>
                                        <Icon type="plus-circle" style={{ color: '#52c41a' }} />
                                        {' Novas '}
                                        <Tag color="green" style={{ marginLeft: 4 }}>{totalCreated}</Tag>
                                    </span>
                                }
                                key="created"
                            >
                                <Table
                                    dataSource={created}
                                    rowKey="id"
                                    size="small"
                                    pagination={totalCreated > 10 ? { pageSize: 10, size: 'small' } : false}
                                    scroll={totalCreated > 8 ? { y: 320 } : undefined}
                                >
                                    <Column
                                        title="Empresa"
                                        key="customer"
                                        ellipsis
                                        render={function(_, record) {
                                            var cod = record.customer_cod ? record.customer_cod + ' - ' : '';
                                            return (
                                                <span>
                                                    <span style={{ color: '#8c8c8c' }}>{cod}</span>
                                                    <span style={{ fontWeight: 500 }}>{record.customer_name}</span>
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column
                                        title="Mensalidade"
                                        dataIndex="amount"
                                        key="amount"
                                        width={150}
                                        align="right"
                                        render={function(val) {
                                            return <span style={{ fontWeight: 500 }}>{toBRL(val)}</span>;
                                        }}
                                    />
                                    <Column
                                        title="13º Salário"
                                        dataIndex="amount13"
                                        key="amount13"
                                        width={150}
                                        align="right"
                                        render={function(val) {
                                            return val > 0
                                                ? <span style={{ fontWeight: 500 }}>{toBRL(val)}</span>
                                                : <span style={{ color: '#bfbfbf' }}>-</span>;
                                        }}
                                    />
                                </Table>
                            </TabPane>
                        )}
                        {totalUpdated > 0 && (
                            <TabPane
                                tab={
                                    <span>
                                        <Icon type="edit" style={{ color: '#1890ff' }} />
                                        {' Atualizadas '}
                                        <Tag color="blue" style={{ marginLeft: 4 }}>{totalUpdated}</Tag>
                                    </span>
                                }
                                key="updated"
                            >
                                <Table
                                    dataSource={updated}
                                    rowKey="id"
                                    size="small"
                                    pagination={totalUpdated > 10 ? { pageSize: 10, size: 'small' } : false}
                                    scroll={totalUpdated > 8 ? { y: 320 } : undefined}
                                >
                                    <Column
                                        title="Empresa"
                                        key="customer"
                                        ellipsis
                                        render={function(_, record) {
                                            var cod = record.customer_cod ? record.customer_cod + ' - ' : '';
                                            return (
                                                <span>
                                                    <span style={{ color: '#8c8c8c' }}>{cod}</span>
                                                    <span style={{ fontWeight: 500 }}>{record.customer_name}</span>
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column
                                        title="Mensalidade"
                                        key="amount_change"
                                        width={250}
                                        align="right"
                                        render={function(_, record) {
                                            if (record.old_amount === record.amount) {
                                                return <span style={{ fontWeight: 500 }}>{toBRL(record.amount)}</span>;
                                            }
                                            var diff = record.amount - record.old_amount;
                                            var isIncrease = diff > 0;
                                            return (
                                                <span>
                                                    <span style={{ color: '#bfbfbf', textDecoration: 'line-through', fontSize: 12 }}>
                                                        {toBRL(record.old_amount)}
                                                    </span>
                                                    <Icon type="arrow-right" style={{ margin: '0 6px', fontSize: 10, color: '#bfbfbf' }} />
                                                    <span style={{ fontWeight: 600, color: isIncrease ? '#f5222d' : '#52c41a' }}>
                                                        {toBRL(record.amount)}
                                                    </span>
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column
                                        title="13º Salário"
                                        key="amount13_change"
                                        width={250}
                                        align="right"
                                        render={function(_, record) {
                                            if (record.old_amount13 === record.amount13) {
                                                return record.amount13 > 0
                                                    ? <span style={{ fontWeight: 500 }}>{toBRL(record.amount13)}</span>
                                                    : <span style={{ color: '#bfbfbf' }}>-</span>;
                                            }
                                            var diff = record.amount13 - record.old_amount13;
                                            var isIncrease = diff > 0;
                                            return (
                                                <span>
                                                    <span style={{ color: '#bfbfbf', textDecoration: 'line-through', fontSize: 12 }}>
                                                        {toBRL(record.old_amount13)}
                                                    </span>
                                                    <Icon type="arrow-right" style={{ margin: '0 6px', fontSize: 10, color: '#bfbfbf' }} />
                                                    <span style={{ fontWeight: 600, color: isIncrease ? '#f5222d' : '#52c41a' }}>
                                                        {toBRL(record.amount13)}
                                                    </span>
                                                </span>
                                            );
                                        }}
                                    />
                                </Table>
                            </TabPane>
                        )}
                    </Tabs>
                )}

                <div style={{ textAlign: 'right', marginTop: 20 }}>
                    <Button type="primary" size="large" onClick={onClose}>
                        Fechar
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default GenerateSummaryModal;
